import { SectionHeader } from "../../../components/SectionHeader/SectionHeader";

import "./Card.scss";
import { QuickBooks } from "./Quickbooks";

export function Integrations() {
  return (
    <section>
      <SectionHeader title="Integrations" />
      <QuickBooks />
    </section>
  );
}
